import styled from "styled-components";

export const Title = styled.h2`
  text-align: center;
  color: var(--primary-color);
  font-family: Merriweather;
  font-size: 28qw;
  font-style: normal;
  font-weight: 700;
  line-height: 1.21;

  margin-top: 80px;
`;
